import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { AuthErrorInterceptor } from './shared/auth-error.interceptor';
import { SessionTimeoutService } from './services/session-timeout.service';

// `en-US` is Angular's built-in default locale — no `registerLocaleData` call
// is needed. The `LOCALE_ID` provider below makes the choice explicit so a
// future config change can't silently swap the locale.

// Modular AngularFire imports
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { initializeAppCheck, provideAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { SharedModule } from './shared/shared.module';
import { UtilService } from './shared/services/util.service';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';

// Set debug token for dev environment (allows all developers to use the same token)
if (!environment.production && typeof window !== 'undefined') {
  (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = '31148d4f-6a67-4098-a06e-dfa0f78c6e64';
}

@NgModule({
  declarations: [
    AppComponent,
    TermsConditionsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,

    // Modular Firebase - App Check инициализируется ПЕРЕД Auth
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAppCheck(() => initializeAppCheck(undefined, {
      provider: new ReCaptchaEnterpriseProvider(environment.recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true
    })),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideDatabase(() => getDatabase()),
  ],
  providers: [
    UtilService,
    DatePipe,
    { provide: LOCALE_ID, useValue: 'en-US' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthErrorInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [SessionTimeoutService],
      useFactory: (svc: SessionTimeoutService) => () => {
        svc.start();
      },
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
